/// <amd-module name="Wiki/HeaderMetaData/EditorComponent" />
import * as React from "react";
import { IdentityDetailsProvider } from "VSS/Features/Identities/IdentityDetailsProvider";
import { IVssPageContext } from "VSS/Platform/Context";
import { IdentityRef, TeamMember } from "VSS/Platform/Contracts/WebApi";
import { Tooltip } from "VSSUI/TooltipEx";
import { Location } from "VSSUI/Utilities/Position";
import { VssPersona } from "VSSUI/VssPersona";

export const EditorComponent = (props: { identity: IdentityRef; pageContext: IVssPageContext }): JSX.Element => {
    const teamMember: TeamMember = {
        identity: props.identity,
        isTeamAdmin: false
    };
    const identityDetailsProvider = new IdentityDetailsProvider(props.pageContext, teamMember);

    return (
        <div className="flex-row flex-center">
            <VssPersona className={"cursor-pointer"} size={"extra-small"} identityDetailsProvider={identityDetailsProvider} isTabStop={true} />
            <Tooltip
                overflowOnly={true}
                text={props.identity.displayName}
                tooltipOrigin={{ horizontal: Location.center, vertical: Location.start }}
                anchorOrigin={{ horizontal: Location.center, vertical: Location.end }}
            >
                <div className="wiki-last-edited-by-name flex-grow text-ellipsis">{props.identity.displayName}</div>
            </Tooltip>
        </div>
    );
};
